
define('text!templates/modules/calendar/animated-session/animation/rename/custom-names-content.html',[],function () { return '<div id="custom-names-content" class="panel-body">\n    <div id="custom-names-list"></div>\n</div>\n';});

